<template>
  <div class="box">
    <div class="comments">
      <v-list three-line>
        <template v-for="(request, index) in reviewRequests">
          <v-list-item v-bind:key="index" class="border-bottom" @click="selectItem(request)">
            <v-list-item-content class="mt-2">
              <v-list-item-title style="font-size: 14px;" v-html="highlightLinks(request.commitMsg)"></v-list-item-title>
              <v-list-item-subtitle>
                <p class="mt-2">
                  <span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="cursor-default" v-bind="attrs" v-on="on">
                          <v-avatar
                              color="gray_2"
                              size="24"
                              style="color: #fff; font-size: 12px;"
                          >{{initials(request.reviewer)}}</v-avatar>
                        </span>
                      </template>
                      <span>{{ request.reviewer }}</span>
                    </v-tooltip>
                  </span>
                  <v-icon small>mdi-circle-small</v-icon>
                  <span class="sub cursor-default">{{request.createdDate | moment("DD.MM.YYYY HH:mm")}}</span>
                </p>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
   
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    reviewRequests: Array
  },
  data: function() {
    return {
    };
  },
  mounted: function() {
  },
  computed: {},
  methods: {
    initials(email){
      let initials = email.substring(0,2).toUpperCase();
      return initials;
    },
    highlightLinks(text) {
      // Regular expression to match URLs
      const urlRegex = /((http|https):\/\/[^\s]+)/g;

      // Replace URLs with anchor tags
      const highlightedText = text.replace(urlRegex, '<a href="$&" target="_blank">$&</a>');

      return highlightedText;
    },
    changeRequestState(request, state){
      request.requestState = state;
      this.reviewRequests.forEach(obj => obj.requestState = obj.createdDate < request.createdDate ? state : obj.requestState);
    },
    selectItem(request){
      this.$emit("selectItem", request);
    }
  }
};
</script>
<style scoped>
.comments,
.newComment {
  position: absolute;
}
.comments {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
}
.newComment {
  bottom: 0;
  right: 0;
  left: 0;
  height: 100px;
}
.box {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
.sub {
  font-size: 0.7rem;
}
#accept{
    width:50%;
}

#reject{
    width:50%;
}
</style>